import React, { useState, useEffect } from "react";
import Header from "../Components/Common/Header";
import AttendanceTable from "../Components/Admin/AttendanceTable";
import "../Styles/Admin/AttendancePage.css";
import { 
  ClipboardList,
  Search, 
  Calendar, 
  RefreshCw,
  X
} from "lucide-react";

const AttendancePage = () => {
  const today = new Date();
  const tomorrow = new Date(today);

  const formatDate = (date) => date.toISOString().split("T")[0]; 

  const [filters, setFilters] = useState({
    searchQuery: "",
    startDate: formatDate(today),
    endDate: formatDate(tomorrow),
  });

  const [appliedFilters, setAppliedFilters] = useState({...filters}); 
  const [isSearching, setIsSearching] = useState(false);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSearch = async () => {
    try {
      setIsSearching(true);
      setAppliedFilters({ ...filters });
      
      setTimeout(() => {
        setIsSearching(false);
      }, 500);
    } catch (error) {
      // checkTokenExpiration(error);
    } finally {
      setIsSearching(false);
    }
  };

  const handleClear = () => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    const formatDate = (date) => date.toISOString().split("T")[0]; 
    const defaultFilters = {
      searchQuery: "",
      startDate: formatDate(today),
      endDate: formatDate(tomorrow),
    };
  
    setFilters(defaultFilters);
    setAppliedFilters(defaultFilters);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div className="ap-container">
      <div className="ap-wrap-content">
<Header title="Attendance History" description="Track and monitor employee attendance records"  icon={<ClipboardList size={28} color="#f3f4f6" />}/>

      <div className="ap-content">
        {/* Main Filters Bar */}
        <div className="ap-filters-card">
          <div className="ap-filters-row">
            <div className="ap-search-container">
              <Search className="ap-search-icon" size={18} />
              <input
                type="text"
                name="searchQuery"
                placeholder="Search by name or email"
                value={filters.searchQuery}
                onChange={handleFilterChange}
                onKeyPress={handleKeyPress}
                className="ap-search-input"
              />
            </div>
            
            <div className="ap-date-filters">
              <div className="ap-date-input-container">
                <Calendar size={16} className="ap-date-icon" />
                <input
                  type="date"
                  name="startDate"
                  value={filters.startDate}
                  onChange={handleFilterChange}
                  className="ap-date-input"
                />
              </div>
              
              <span className="ap-date-separator">to</span>
              
              <div className="ap-date-input-container">
                <Calendar size={16} className="ap-date-icon" />
                <input
                  type="date"
                  name="endDate"
                  value={filters.endDate}
                  onChange={handleFilterChange}
                  className="ap-date-input"
                />
              </div>
            </div>
          </div>
          
          <div className="ap-actions">
            <button 
              className="ap-search-btn" 
              onClick={handleSearch}
              disabled={isSearching}
            >
              {isSearching ? (
                <>
                  <RefreshCw size={16} className="ap-spinner" />
                  <span>Searching...</span>
                </>
              ) : (
                <>
                  <Search size={16} />
                  <span>Search</span>
                </>
              )}
            </button>
            
            <button 
              className="ap-clear-btn" 
              onClick={handleClear}
            >
              <X size={16} />
              <span>Clear</span>
            </button>
          </div>
        </div>
        
        {/* Attendance Table */}
        <div className="ap-table-section">
          <AttendanceTable filters={appliedFilters} />
        </div>
      </div>
      </div>
     
    </div>
  );
};

export default AttendancePage;
